import { render, staticRenderFns } from "./DatasetTextAnnotation.vue?vue&type=template&id=bc874f16&scoped=true&"
import script from "./DatasetTextAnnotation.vue?vue&type=script&lang=js&"
export * from "./DatasetTextAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTextAnnotation.vue?vue&type=style&index=0&id=bc874f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc874f16",
  null
  
)

export default component.exports